import React from "react";
import _ from "lodash";
import { useDispatch, useSelector } from "react-redux";
import { FormField } from "./Form";
import Select from "../SelectInput/SelectCompat";
import { required } from "../../utils/formValidations";
import { getImageEgressGateways } from "../../actions/actionDashboard";
import { useTranslation } from "react-i18next";


export function EgressForm(props) {
  const { t } = useTranslation('common');
  const kasmData = props.data
  const { setGatewayId } = props
  const imageEgressGatewayDict = useSelector(state => state.dashboard.imageEgressGatewayDict)
  const [imageEgressGateways, setImageEgressGateways] = React.useState([]);
  const [providerError, setProviderError] = React.useState(null);
  const [countryError, setCountryError] = React.useState(null);
  const [cityError, setCityError] = React.useState(null);
  const [gatewayError, setGatewayError] = React.useState(null);
  const [userEgressProvider, setUserEgressProvider] = React.useState('none');
  const [userEgressGatewayCountry, setUserEgressGatewayCountry] = React.useState(false);
  const [userEgressGatewayCity, setUserEgressGatewayCity] = React.useState(false);
  const [userEgressGateway, setUserEgressGateway] = React.useState(null);
  const [egressProviders, setEgressProviders] = React.useState([]);
  const [egressCountries, setEgressCountries] = React.useState([]);
  const [egressCities, setEgressCities] = React.useState([]);
  const [egressGateways, setEgressGateways] = React.useState([]);
  const [gatewayList, setGatewayList] = React.useState([]);
  const lng = localStorage.getItem('i18nextLng') || 'en'
  const regionNamesInLocal = new Intl.DisplayNames([lng], { type: 'region' });
  const dispatch = useDispatch()


  React.useEffect(() => {
    const userInfo = JSON.parse(window.localStorage.getItem("user_info"));
    if (userInfo && userInfo.username && userInfo.token) {
      dispatch(getImageEgressGateways(kasmData.image_id))
    }
  }, [kasmData]);

  React.useEffect(() => {
    if (imageEgressGatewayDict == null) {
      setImageEgressGateways([])
      return
    }
    const image_gateways = imageEgressGatewayDict[kasmData.image_id]
    if (image_gateways == null) {
      setImageEgressGateways([])
      return
    }
    setImageEgressGateways(image_gateways)

  }, [imageEgressGatewayDict, kasmData]);

  React.useEffect(() => {
    if (!_.isEmpty(egressProviders)) {
      if (!egressProviders.some(el => el.value === userEgressProvider)) {
        setUserEgressProvider(null)
        setProviderError(<div className="tw-my-3 tw-mb-2 tw-text-rose-400 tw-text-xs">{t('workspaces.previous-data-invalid')}</div>)
      }
    }
  }, [userEgressProvider]);

  React.useEffect(() => {
      const gatewayId = getEgressGatewayId()
      setGatewayId(gatewayId)
  }, [egressGateways, userEgressGateway]);

  React.useEffect(() => {
    // Get gateway list
    let list = [
      ...imageEgressGateways,
    ]
    if (kasmData && 'egress_gateways' in kasmData) {
      list = [
        ...list,
        ...kasmData.egress_gateways
      ]
    }
    setGatewayList(list)
  }, [kasmData, imageEgressGateways]);


  const getUniqueOptionList = (options) => {
    let track = new Set()
    return options.filter(({ value }) => (track.has(value) ? false : track.add(value)))
  }

  const getEgressGatewayId = () => {
    if (kasmData && kasmData.image_type !== "Container") {
      return null
    }
    if (!egressGateways || egressGateways.length <= 0) {
      return null
    }
    const localEgressGateways = egressGateways.filter(({ value }) => value !== 'any')
    if (userEgressGateway == null || userEgressGateway === 'any') {
      // user hasn't set an egress gateway or any is selected then we set gateway to a random gateway in the filtered list of gateways
      return localEgressGateways[Math.floor(Math.random() * localEgressGateways.length)].value
    }
    return userEgressGateway
  }

  React.useEffect(() => {
    // Get Egress Provider Options

    if (gatewayList == null || gatewayList.length === 0) {
      setEgressProviders([])
      return
    }

    let localEgressProviders = gatewayList.map(({ egress_provider_name }) => ({ value: egress_provider_name, label: egress_provider_name }))
      .sort(function (a, b) {
        if (a.label > b.label) return 1;
        if (a.label < b.label) return -1;
        return 0;
      })

    localEgressProviders = getUniqueOptionList(localEgressProviders)
    if (localEgressProviders.length > 0) {
      if (!kasmData.override_egress_gateways) {
        localEgressProviders.unshift({ label: 'None', value: 'none' })
      }
    } else {
      setUserEgressProvider(localEgressProviders[0].value)
    }
    setEgressProviders(localEgressProviders)
  }, [gatewayList])

  React.useEffect(() => {
    // Get country options
    if (gatewayList == null || gatewayList.length === 0) {
      setEgressCountries([])
      return
    }
    let localEgressGateways = gatewayList.filter(({ egress_provider_name }) => egress_provider_name === userEgressProvider)
    let egressCountries = localEgressGateways.map(({ country }) => ({ value: country, label: /^[A-Z]{2}$/.test(country) ? regionNamesInLocal.of(country) : country }))
      .sort(function (a, b) {
        if (a.label > b.label) return 1;
        if (a.label < b.label) return -1;
        return 0;
      })

    egressCountries = getUniqueOptionList(egressCountries)
    if (egressCountries.length > 1) {
      egressCountries.unshift({ label: 'Any', value: 'any' })
    } else if (egressCountries.length === 1) {
      setUserEgressGatewayCountry(egressCountries[0]?.value)
    }
    setEgressCountries(egressCountries)
  }, [gatewayList, egressProviders, userEgressProvider])

  React.useEffect(() =>{
    // Get city options
    if (gatewayList == null || gatewayList.length === 0) {
      setEgressCities([])
      return
    }
    let localEgressGateways = gatewayList.filter(({ egress_provider_name }) => egress_provider_name === userEgressProvider)
    if (userEgressGatewayCountry && userEgressGatewayCountry !== 'any') {
      localEgressGateways = localEgressGateways.filter(({ country }) => country === userEgressGatewayCountry)
    }
    let egressCities = localEgressGateways.map(({ city }) => ({ value: city, label: city }))
      .sort(function (a, b) {
        if (a.label > b.label) return 1;
        if (a.label < b.label) return -1;
        return 0;
      })

    egressCities = getUniqueOptionList(egressCities)

    if (egressCities.length > 1) {
      egressCities.unshift({ label: 'Any', value: 'any' })
    } else if (egressCities.length === 1) {
      setUserEgressGatewayCity(egressCities[0]?.value)
    }
    setEgressCities(egressCities)
  }, [gatewayList, egressProviders, userEgressProvider, egressCountries, userEgressGatewayCountry])

  React.useEffect(() => {
    // Get EgressGatewayOptions
    if (gatewayList == null || gatewayList.length === 0) {
      setEgressGateways([])
      return
    }
    let localEgressGateways = gatewayList.filter(({ egress_provider_name }) => egress_provider_name === userEgressProvider)
    if (userEgressGatewayCountry && userEgressGatewayCountry !== 'any') {
      localEgressGateways = localEgressGateways.filter(({ country }) => country === userEgressGatewayCountry)
    }
    if (userEgressGatewayCity && userEgressGatewayCity !== 'any') {
      localEgressGateways = localEgressGateways.filter(({ city }) => city === userEgressGatewayCity)
    }

    localEgressGateways = localEgressGateways.map(({ egress_gateway_name, egress_gateway_id }) => ({ value: egress_gateway_id, label: egress_gateway_name }))
      .sort(function (a, b) {
        if (a.label > b.label) return 1;
        if (a.label < b.label) return -1;
        return 0;
      })

    localEgressGateways = getUniqueOptionList(localEgressGateways)

    if (localEgressGateways.length > 1) {
      localEgressGateways.unshift({ label: 'Any', value: 'any' })
    } else if (localEgressGateways.length === 1) {
      setUserEgressGateway(localEgressGateways[0]?.value)
    }
    setEgressGateways(localEgressGateways)
  }, [gatewayList,  egressProviders, userEgressProvider, egressCountries, userEgressGatewayCountry, egressCities, userEgressGatewayCity])

  return (
    <React.Fragment>
      {kasmData && kasmData.image_type === "Container" && egressProviders && egressProviders.length > 0 ? (
        <FormField section="egress_provider" label="egress-provider-id" className="" save={'egress_provider-' + kasmData.image_id.replaceAll('-', '')} additional={providerError} setSavedValue={(data) => { setUserEgressProvider(data); }}>
          <Select
            className="input"
            id="egress_provider"
            key={kasmData.image_id}
            value={userEgressProvider}
            options={egressProviders}
            name="egress_provider"
            validate={required} required
            onChange={(e) => {
              setUserEgressProvider(e.value)
              setUserEgressGatewayCountry(null)
              setUserEgressGatewayCity(null)
              setUserEgressGateway(null)
            }}
          />
        </FormField>
      ) : (
        ""
      )}
      {egressCities && egressCountries && egressGateways && userEgressProvider && userEgressProvider != 'none' ? (
        <React.Fragment>
          <FormField section="egress_provider" label="country" className="" save={'egress_gateway_country-' + kasmData.image_id.replaceAll('-', '')} additional={countryError} options={egressCountries} setSavedValue={(data) => { setUserEgressGatewayCountry(data); }}>
            <Select
              className="input"
              id="egress_gateway_country"
              key={kasmData.image_id}
              value={userEgressGatewayCountry || 'any'}
              options={egressCountries}
              name="egress_gateway_country"
              validate={required} required
              onChange={(e) => {
                setUserEgressGatewayCountry(e.value)
                setUserEgressGatewayCity(null)
                setUserEgressGateway(null)
              }}
            />
          </FormField>
          <FormField section="egress_provider" label="city" className="" save={'egress_gateway_city-' + kasmData.image_id.replaceAll('-', '')} additional={cityError} setSavedValue={(data) => { setUserEgressGatewayCity(data); }}>
            <Select
              className="input"
              id="egress_gateway_city"
              key={kasmData.image_id}
              value={userEgressGatewayCity || 'any'}
              options={egressCities}
              name="egress_gateway_city"
              validate={required} required
              onChange={(e) => {
                setUserEgressGatewayCity(e.value)
                setUserEgressGateway(null)
              }}
            />
          </FormField>
          <FormField section="egress_provider" label="egress-gateway" className="" save={'egress_gateway-' + kasmData.image_id.replaceAll('-', '')} additional={gatewayError} setSavedValue={(data) => setUserEgressGateway(data)}>
            <Select
              className="input"
              id="egress_gateway"
              key={kasmData.image_id}
              value={userEgressGateway || 'any'}
              options={egressGateways}
              name="egress_gateway"
              validate={required} required
              onChange={(e) => {
                setUserEgressGateway(e.value)
              }}
            />
          </FormField>
        </React.Fragment>
      ) : (
        ""
      )}

    </React.Fragment>
  )
}



